import React from 'react';

const NebulaStatisticsFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaStatisticsModalRegistry = {
    personalize_nebulaStatisticsId: NebulaStatisticsFormModal
};
export default nebulaStatisticsModalRegistry;
